




































import { defineComponent, ref } from "@vue/composition-api";
import Page from "@/components/layout/page.vue";
import PageHeader from "@/components/navigation/page-header.vue";
import DataTable from "@/components/data/data-table.vue";
import { Floor } from "@/swagger/models";
import { DataTableConfig, DataTableField } from "@/components/data/data-table";
import { useRouter } from "@/router/router";
import { floorService } from "@/services/floor";

export default defineComponent({
    name: "floors-table",
    props: {
        officeId: {
            type: Number,
            required: true,
        },
    },
    components: { Page, PageHeader, DataTable },
    setup(props, context) {
        const { router } = useRouter(context);

        const floors = ref<Floor[]>([]);
        const loading = ref(false);

        (async () => {
            loading.value = true;
            floors.value = await floorService.find({ params: { office: props.officeId } });
            loading.value = false;
        })();

        const tableConfig: DataTableConfig<Floor> = {
            clickItemCallback: (item) => {
                router.push({
                    name: "floor",
                    params: {
                        floorId: item.id.toString(),
                    },
                });
            },
            items: floors,
            fields: [
                {
                    label: "ID",
                    field: "id",
                    compact: true,
                },
                {
                    label: "Name",
                    field: "name",
                },
                {
                    label: "Level",
                    field: "level",
                },
                {
                    label: "Created",
                    field: "createdAt",
                    compact: true,
                },
                {
                    label: "Updated",
                    field: "updatedAt",
                    compact: true,
                },
            ] as DataTableField<Floor>[],
        };

        return { tableConfig, loading };
    },
});
